export const BRAND = {
    name: "HYPE SNEAKERS 21",
    logo: "https://customer-assets-4nw71qhi.emergentagent.net/job_kicks-gallery-45/artifacts/u3a6m6mw_IMG_8576.PNG",
    instagramHandle: "@hype_sneakers21",
    instagramUrl: "https://instagram.com/hype_sneakers21",
    dmUrl: "https://ig.me/m/hype_sneakers21",
};

export const IMAGES = {
    hero: "https://images.unsplash.com/photo-1556906781-9a412961c28c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwb3V0Zml0JTIwc25lYWtlcnN8ZW58MHx8fHwxNzkwODcyODI4fDA&ixlib=rb-4.1.0&q=85",
    story: "https://images.unsplash.com/photo-1678266622924-c7c38ddc25e1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxzbmVha2VyJTIwc3RvcmUlMjBkaXNwbGF5fGVufDB8fHx8MTc5MDg3MjgyOHww&ixlib=rb-4.1.0&q=85",
};

export const PRODUCTS = [
    {
        id: 1,
        name: "Air Jordan 1",
        image: "https://images.pexels.com/photos/2385477/pexels-photo-2385477.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        id: 2,
        name: "Air Jordan 4",
        image: "https://images.pexels.com/photos/15298948/pexels-photo-15298948.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        id: 3,
        name: "Air Jordan 3",
        image: "https://images.pexels.com/photos/6050919/pexels-photo-6050919.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
    {
        id: 4,
        name: "Nike Dunk",
        image: "https://images.pexels.com/photos/16100364/pexels-photo-16100364.jpeg?auto=compress&cs=tinysrgb&w=800",
    },
];

export const FAQS = [
    {
        q: "Come faccio a ordinare?",
        a: "Semplice: premi 'Scrivici in DM' e si apre direttamente la chat Instagram con noi. Mandaci una foto dell'articolo che vuoi e la tua taglia: ti rispondiamo con disponibilità, prezzo e tempi.",
    },
    {
        q: "Non trovo il modello che cerco. Potete reperirlo?",
        a: "Sì, reperiamo qualsiasi brand e taglia: sneakers, abbigliamento e accessori. Inviaci una foto di quello che cerchi in DM sulla nostra pagina Instagram e ti diciamo in quanto tempo riusciamo a trovarlo e a che prezzo.",
    },
    {
        q: "Le sneakers sono originali?",
        a: "Sì. Ogni paio viene controllato prima della spedizione. La fiducia è tutto in questo gioco: per questo parliamo direttamente con ogni cliente prima di chiudere la vendita.",
    },
    {
        q: "Quanto costa la spedizione?",
        a: "Spediamo ovunque. Costi e tempi dipendono dalla destinazione: scrivici in DM e ti diamo subito un preventivo preciso.",
    },
];
